import {
  isLoggedIn,
  logOut
} from "./../js/utils/auth";

import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import countertest from "./modules/countertest";
import sales from "./modules/sales";
import saleproduct from "./modules/saleproduct";

//export default new Vuex.Store({
const store = new Vuex.Store({
  state: {
    isLoggedIn: false,
    user: {},
  },
  getters: {},
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setLoggedIn(state, payload) {
      state.isLoggedIn = payload;
    },
  },
  actions: {
    loadStoredState(context) {
      context.commit("setLoggedIn", isLoggedIn());
    },
    async loadUser({
      commit,
      dispatch
    }) {
      //console.log("inside loadUser");
      if (isLoggedIn()) {
        try {
          const user = (await axios.get("/api/user")).data;
          //console.log(user);
          commit("setUser", user);
          commit("setLoggedIn", true);
        } catch (error) {
          dispatch("logout");
        }
      }
    },
    logout({
      commit
    }) {
      //console.log("inLogout");
      commit("setUser", {});
      commit("setLoggedIn", false);
      logOut();
    },
  },
  modules: {
    sales,
    saleproduct
  },
});
export default store;